export const FULLSCREEN_MODAL_OPTIONS = {
    fullscreen: true,
    allowEscapeKey: false,
    allowOutsideClick: false
};